import { render, staticRenderFns } from "./generalTab.vue?vue&type=template&id=17d579cd&scoped=true&"
import script from "./generalTab.vue?vue&type=script&lang=js&"
export * from "./generalTab.vue?vue&type=script&lang=js&"
import style0 from "./generalTab.vue?vue&type=style&index=0&id=17d579cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d579cd",
  null
  
)

export default component.exports